import { NodeIdAttrName, NodeIdMissingValue, NodeIdRootValue } from '@common/flare-data/constants/flare-data-node.constant';
import { FlareXMLDeclaration } from '@common/flare/constants/flare-xml-declaration.constant';
import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { defaultToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { OperationAttrName } from '@common/prosemirror/operations/operations.constant';
import { getSchemaAttrs } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

/** Condition XML node names. */
export enum ConditionXmlNodeName {
  Set = 'CatapultConditionTagSet',
  Tag = 'ConditionTag',
}

/** Condition tag XML node attribute names. */
export enum ConditionTagXmlAttributeName {
  Name = 'Name',
  BackgroundColor = 'BackgroundColor',
  Comment = 'Comment',
}

export class ConditionSetSchemaPlugin extends SchemaPlugin {
  nodes: Dictionary<NodeSpec> = {
    doc: {
      content: ConditionXmlNodeName.Set,
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        let xml = FlareXMLDeclaration;

        for (let i = 0; i < node.childCount; i += 1) {
          const child = node.child(i);
          xml += (child.type.spec.toFlareXML ?? defaultToFlareXML)(child, options)
        }

        return xml;
      }
    },

    [ConditionXmlNodeName.Set]: {
      content: 'block*',
      attrs: {
        [NodeIdAttrName]: { default: NodeIdRootValue, skipExport: true },
        [OperationAttrName]: { default: undefined, skipExport: true }
      },
      parseDOM: [{
        tag: ConditionXmlNodeName.Set,
      }],
    },

    [ConditionXmlNodeName.Tag]: {
      group: 'block',
      isVoid: true,
      attrs: {
        [NodeIdAttrName]: { default: NodeIdMissingValue, skipExport: true },
        [ConditionTagXmlAttributeName.Name]: { default: undefined },
        [ConditionTagXmlAttributeName.BackgroundColor]: { default: undefined },
        [ConditionTagXmlAttributeName.Comment]: { default: undefined },
      },
      parseDOM: [{
        tag: ConditionXmlNodeName.Tag,
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, [
            ConditionTagXmlAttributeName.Name,
            ConditionTagXmlAttributeName.BackgroundColor,
            ConditionTagXmlAttributeName.Comment
          ]);
        }
      }],
    },
  };
}
